import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import styles from "./multiple-filterable-attributes.module.scss";
import NbcFilterImage from "./NbcFilterImage";

const MultipleFilterableAttributes = (props) => {
  const { filterableAttributes, iconSize = 20 } = props;

  if (!filterableAttributes) {
    return null;
  }

  return (
    <div className={styles.multiple_filterable_attributes}>
      {Object.keys(filterableAttributes).map((filterKey) => {
        if (!Array.isArray(filterableAttributes[filterKey])) {
          return null;
        }

        return filterableAttributes[filterKey].map((filterValue) => (
          <div key={filterValue} className={styles.filterable_attribute_box}>
            <NbcFilterImage filterKey={filterKey} filterValue={filterValue} size={iconSize} />
            <PAText fontSize={FONT_SIZE[0]}>{filterValue}</PAText>
          </div>
        ));
      })}
    </div>

  );
};

export default MultipleFilterableAttributes;
